import { useSessionContext } from '@common/hooks';
import { EtablissementDto, useDownloadOrganismeEtablissementGeneratedDeclarationMutation } from '@common/services';
import { DsfrModal } from '@common/ui';
import React, { useMemo, useState } from 'react';

export const DownloadDocumentTravailModal = ({ dsfrModal, etablissements = [] }: DownloadDocumentTravailModalProps) => {
  const { organismeId } = useSessionContext();

  const [etablissementId, setEtablissementId] = useState(etablissements?.[0]?.id?.toString());

  const [downloadGeneratedDeclaration, { isLoading }] = useDownloadOrganismeEtablissementGeneratedDeclarationMutation();

  const declarantsOptions = useMemo(() => etablissements.map(({ denominationUsuelle, id }) => ({
    label: denominationUsuelle,
    value: id.toString(),
  })), [etablissements]);

  return (
    <dsfrModal.Component
      title={'Télécharger un document de travail'}
      className={'text-left'}
      size="large"
      topAnchor={false}
      buttons={[
        {
          children: 'ANNULER',
          className: 'text-red-400!',
          doClosesModal: true,
          priority: 'tertiary',
          onClick: () => dsfrModal.close(),
        },
        {
          children: 'TÉLÉCHARGER',
          doClosesModal: false,
          priority: 'primary',
          disabled: isLoading,
          onClick: () => downloadGeneratedDeclaration({
            id: organismeId,
            etablissementId: Number(etablissementId),
            travail: true,
          }),
        },
      ]}>

      <div className={'form-field'}>
        <label htmlFor={'etablissement'}>{'Sélectionnez un établissement'}</label>
        <select
          id={`input-etablissement`}
          className={'form-field-input'}
          value={etablissementId}
          onChange={(e) => setEtablissementId(e.target.value)}
        >
          {declarantsOptions.map(({ label, value }, index) => (
            <option key={`${index}-${value}`} value={value}>{label}</option>
          ))}
        </select>
      </div>
    </dsfrModal.Component>
  );
};

interface DownloadDocumentTravailModalProps {
  dsfrModal: DsfrModal;
  etablissements: EtablissementDto[];
}